const eventClickBookingServiceMyAccount = ({ params, eventName = '', eventCategory = '' }) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: 'generalEvent',
      eventName: `${eventName ? eventName : 'my_account_booking_service_category'}`,
      eventCategory: `${eventCategory ? eventCategory : 'my account page'}`,
      eventAction: `click on ${params.toLowerCase()}`,
    });
  }
};

export default eventClickBookingServiceMyAccount;
